
import { DashboardOutlined,ShoppingCartOutlined, BookOutlined,CarryOutOutlined,UsergroupAddOutlined,SkinOutlined, FileAddOutlined, TagsOutlined, UserOutlined, SafetyCertificateOutlined, CreditCardOutlined,DollarCircleOutlined, PlusOutlined, UnorderedListOutlined, HomeOutlined, MoneyCollectOutlined } from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

/////
const dashBoardNavTree = [

    {
      key: 'dashboards-default',
      path: `${APP_PREFIX_PATH}/dashboards/default`,
      title: 'sidenav.dashboard.default',
      icon: DashboardOutlined,
      breadcrumb: false,
      privileges: ['dashboard'],
      submenu: []
    },
    {
      key: 'Employees',
      path: `${APP_PREFIX_PATH}/employees/`,
      title: 'sidenav.employees',
      icon: UsergroupAddOutlined,
      breadcrumb: false,
      privileges: ['employe', 'pointages'],
      submenu: []
    },
    {
      key: 'Creches',
      path: `${APP_PREFIX_PATH}/creches/`,
      title: 'sidenav.creches',
      icon: HomeOutlined,
      breadcrumb: false,
      submenu: [
        {
          key: 'creches-supplement',
          path: `${APP_PREFIX_PATH}/creches/supplement/`,
          title: 'sidenav.creches.supplement',
          icon: FileAddOutlined,
          breadcrumb: false,
          privileges: ['supplements'],
          submenu: []
        },
        {
          key: 'Creches-section-age',
          path: `${APP_PREFIX_PATH}/creches/AgeSection`,
          title: 'sidenav.creches.sectionAge',
          icon: UserOutlined,
          breadcrumb: false,
          privileges: ['age_sections'],
          submenu: []
        },
        {
          key: 'creches-authorizations',
          path: `${APP_PREFIX_PATH}/creches/authorization`,
          title: 'sidenav.creches.autorisations',
          icon: SafetyCertificateOutlined,
          breadcrumb: false,
          privileges: ['authorizations'],
          submenu: []
        },
        {
          key: 'Creches-types-depenses',
          path: `${APP_PREFIX_PATH}/creches/depensestypes`,
          title: 'sidenav.creches.typesDepenses',
          icon: CreditCardOutlined,
          breadcrumb: false,
          privileges: ['expenses'],
          submenu: []
        },
        {
          key: 'Creches-categories-abonnement',
          path: `${APP_PREFIX_PATH}/creches/SubscriptionCategories`,
          title: 'sidenav.creches.categoriesAbonnement',
          icon: TagsOutlined,
          breadcrumb: false,
          privileges: ['subscription_categories'],
          submenu: []
        }
      
      ]
    },
    {
      key: 'Creches-liste-dipenses',
      path: `${APP_PREFIX_PATH}/creches/dipenses`,
      title: 'sidenav.creches.dipenses',
      icon: MoneyCollectOutlined,
      breadcrumb: false,
      privileges: ['expenses'],
      submenu: []
    },
    {
      key: 'Classes',
      path: `${APP_PREFIX_PATH}/Classes/`,
      title: 'sidenav.classes',
      icon: BookOutlined,
      breadcrumb: false,
      privileges: ['classes'],
      submenu: []
    }, 
    {
      key: 'Childrens',
      path: `${APP_PREFIX_PATH}/Childrens/`,
      title: 'sidenav.childrens',
      icon: SkinOutlined,
      breadcrumb: false,
      privileges: ['children'],
      submenu: []
    },
    {
      key: 'Finances Enfants',
      path: `${APP_PREFIX_PATH}/FinancesEnfants/`,
      title: 'sidenav.FinancesEnfants',
      icon: DollarCircleOutlined,
      breadcrumb: false,
      privileges: ['payments', 'invoices'],
      submenu: []
    }, 
    {
      key: 'gestionBesoins',
      path: `${APP_PREFIX_PATH}/gestionBesoins/`,
      title: 'sidenav.gestionBesoins',
      icon: ShoppingCartOutlined,
      breadcrumb: false,
      privileges: ['needs', 'achats'],
      submenu: []
    }, 
    {
      key: 'gestionUsers',
      path: `${APP_PREFIX_PATH}/gestionUsers/`,
      title: 'sidenav.gestionUsers',
      icon: UserOutlined,
      breadcrumb: false,
      privileges: ['users'],
      submenu: []
    }, 
  
  

];

const navigationConfig = [
  ...dashBoardNavTree
]

export default navigationConfig;
